const REPLACE = "replace";
const SET = "set";

export const ACTION_TYPE = {
  REPLACE,
  SET
};
